/* eslint-disable import/order */
import { MenuIdAddons } from '@jira/navigation-apps__constants/src/MenuIdAddons.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { promotionsRoute } from '@jira/router-routes__marketplace-routes/src/promotionsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyMarketplace, MarketplaceComponent } from './ui/MarketplaceComponent.tsx';

export const promotionsRouteEntry: Route = createEntry(promotionsRoute, () => ({
	group: 'marketplace',
	// eslint-disable-next-line no-restricted-syntax
	component: MarketplaceComponent,

	navigation: {
		sidebarId: SidebarIdGlobalAppsSettings,
		menuId: MenuIdAddons,
	},

	layout: globalLayout,

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarGlobalSettingsResources(),
		navigationSidebarGlobalResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyMarketplace],
	ufoName: 'embedded-marketplace',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
